<template>
  <div>
    <div class="container-fluid my-account">
      <div class="row">
        <div class="col-md-12">
          <div class="success_message" v-text="this.$root.success_message" v-if="this.$root.success_message != ''">
          </div>
          <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
        </div>
        <div class="col-md-3">
          <ul class="sidebar">
            <li>
              <router-link :to="{name:'dashboard'}">Account Dashboard</router-link>
            </li>
            <li>
              <router-link :to="{name:'order'}">My Orders</router-link>
            </li>
            <li>
              <router-link :to="{name:'address_book'}">Address Book</router-link>
            </li>
            <li class=" active">
              <router-link :to="{name:'return'}">Manage Return/Exchange</router-link>
            </li>
            
          </ul>
        </div>

        <div class="col-md-9">
          <div class="row">
            <div class="col-md-12">
              <button class="pull-right create-return" @click="order_return">Request Return</button>
              <button class="pull-right create-exchange" @click="order_exchange">Request Exchange</button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="content-box">
                <table class="table order-table">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Order #</th>
                      <th>Date</th>
                      <th>QTY</th>
                      <th>Size</th>
                      <!--th>Status</th-->
                      <th>Reason</th>
                      <th class="text-right">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(items,index) in order" v-if="order.length">

                      <td>
						   <responsive-image
            
								v-bind:desktop="`${$root.image_url_c}inside/900x450/${items.image}`"
								v-bind:tab="`${$root.image_url_c}inside/600x280/${items.image}`"
								v-bind:mobile="`${$root.image_url_c}inside/650x280/${items.image}`"
								v-bind:default_image="`${$root.image_url_c}inside/800x250/${items.image}`"
								width='60px'
									
							/>
						  <span>{{items.name}}</span></td>
                      <td v-text="items.order_id" class="order"></td>
                      <td v-text="items.created_at" class="order-date"></td>
                      <td v-text="items.qty" class="qty"></td>
                      <td v-if="items.size !== null" class="size">{{items.size}}</td>
                      <td v-else class="size">-</td>
                      <td v-if="items.return_reasons !== null" class="reasons">{{items.return_reasons}}</td>
                      <td v-else class="reasons">-</td>
                      <td v-text="items.item_status"  class="status text-right"></td>
                    </tr>
                    <tr v-if="!order.length">
                      <p class="p-2"> Return order not found</p>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="return_modal" class="modal" v-bind:class="[this.return_popup? '' : 'active']">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title font-bold">Request Return</h4><button type="button" class="close"
              @click="close_popup()">×</button>
          </div>
          <div class="modal-body">
            <div class="field select-order col-md-6 col-12 p-0 mb-3">
              <select class="input-text form-control" v-model="select_o_n">
                <option value="">--Select order no--</option>
                <option v-for="(item,i) in latestorder" :value="i">{{i}}</option>
              </select>
            </div>
            <table class="table order-table" v-if="select_o_n!=''">
              <thead>
                <tr>
                  <th class="font-bold">Name</th>
                  <th class="font-bold">QTY</th>
                  <th class="font-bold">Total</th>
                  <th class="font-bold">Date</th>
                  <th class="text-right font-bold">Action</th>
                </tr>
              </thead>
              <tbody v-for="(items,index) in latestorder[select_o_n].order_items">
                <tr>
                  <td>
					   <responsive-image
            
								v-bind:desktop="`${$root.image_url_c}inside/900x450/${items.image}`"
								v-bind:tab="`${$root.image_url_c}inside/600x280/${items.image}`"
								v-bind:mobile="`${$root.image_url_c}inside/650x280/${items.image}`"
								v-bind:default_image="`${$root.image_url_c}inside/800x250/${items.image}`"
								width='60px'
									
							/>
					  <span>{{items.name}}</span></td>
                  <td class="qty cart-item">
                    {{items.qty}}
                    
                  </td>
                  <td class="total">Rs. {{items.row_total}}</td>
                  <td v-text="items.created_at" class="order-date"></td>
                  <td class="action text-right"><a href="#" @click.prevent="select_item(index)" v-if="index != return_id && Object.keys(latestorder[select_o_n].order_items).length > 1">Return</a></td>
                </tr>
                <tr v-if="index==return_id || Object.keys(latestorder[select_o_n].order_items).length == 1">
                  <td colspan="5" class="select-order">
                    <form class="reasons_form reasons_form_return" @submit="request_return(select_o_n,index,items.qty,items.name,items.sku)">
                      <div class="reason-container mb-3 w-100 cart-item">
                      <label>Select Quantity</label>
                      <div class="qty_box" style="width: 130px;">
                      <a href="#" class="" @click.prevent="qty_minus" v-bind:class="{disabled:qty == 1}"><i class="fa fa-minus"></i></a>
                        <input type="text" :max="items.qty" min="1" v-model="qty" readonly="readonly">
                      <a href="#" class="" @click.prevent="qty_plus(items.qty)" v-bind:class="{disabled:items.qty == qty}"><i class="fa fa-plus"></i></a><span> /</span> <span>{{items.qty}}</span>
                      </div>
                      <div class="total_price">Total:  Rs. {{(items.row_total * qty) / items.totalQty }}</div>
                      </div>
                      <div class="reason-container mb-3 w-100">
                      <!-- <label>Return Reasons</label> -->
                      <select class="input-text form-control" v-model="select_resion" required>
                        <option value="">--Select Return Reasons--</option>
                        <option value="Size Fit Issue">Size Fit Issue</option>
                        <option value="Received a different size">Received a different size</option>
                        <option value="Received a different Color">Received a different Color</option>
                        <option value="Quality Issue">Quality Issue</option>
                        <option value="Item no loger wanted">Item no loger wanted</option>
                        <option value="Item or part was broken/Damaged on Arrival">Item or part was broken/Damaged on Arrival</option>
                        <option value="Expected a different style/Fit">Expected a different style/Fit</option>
                      </select>
                      </div>
                      <div class="reason-container comments mb-3">
                        <!-- <label>Exchange Reason</label> -->
                        <textarea class="w-100 form-control" placeholder="Comments (optional)" maxlength="490" v-model="return_comment"></textarea>
                      </div>
                      <div class="account_info" v-show = "!latestorder[select_o_n].accountInfo && latestorder[select_o_n].ordertype == 'cod'">
                        <h2>For refund, please enter your account details below</h2>
                      <div class="reason-container w-100 mb-3">
                        <!-- <label>Account Holder Name</label> -->
                        <input type="text" class="w-100 form-control" placeholder="Account Holder Name*" @keyup="select_holder_name" v-model="ac_holder_name">
                        <p style="color:red;font-size:var(--font-size-regular);">{{ac_holder_name_error}}</p>
                      </div>
                      <div class="reason-container w-50 mb-3">
                        <!-- <label>Account Number</label> -->
                        <input type="password" class="w-100 form-control" placeholder="Account Number*" @keyup="select_ac_number" v-model="ac_number">
                        <p style="color:red;font-size:var(--font-size-regular);">{{ac_number_error}}</p>
                      </div>
                      <div class="reason-container w-50 mb-3 pl-3">
                        <!-- <label>Re-enter Account Number</label> -->
                        <input type="number" class="w-100 form-control" placeholder="Re-enter Account Number*"  @keyup="re_select_ac_number" v-model="re_ac_number">
                        <p style="color:red;font-size:var(--font-size-regular);">{{re_ac_number_error}}</p>
                      </div>
                      <div class="reason-container w-100 mb-3">
                        <!-- <label>IFSC Code</label> -->
                        <input type="text" class="w-100 form-control" placeholder="IFSC Code*"  @keyup="select_ifsc_code" v-model="ac_ifsc_code">
                        <p style="color:red;font-size:var(--font-size-regular);">{{ifsc_code_error}}</p>
                      </div>
                      </div>

                      <button class="input-text form-control submit">Submit</button>  
                    </form>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>


<div id="exchange_modal" class="modal" v-bind:class="[this.exchange_popup? '' : 'active']">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title font-bold">Exchange</h4><button type="button" class="close"
              @click="close_popup_ex()">×</button>
          </div>
          <div class="modal-body">
            <div class="field select-order col-md-6 col-12 p-0 mb-3">
              <select class="input-text form-control" v-model="select_o_nx">
                <option value="">--Select order no--</option>
                <option v-for="(item,i) in latestorderex" :value="i" v-if="item.order_items.length !== 0">{{i}}</option>
              </select>
            </div>
            <table class="table order-table" v-if="select_o_nx!=''">
              <thead>
                <tr>
                  <th class="font-bold">Name</th>
                  <th class="font-bold">QTY</th>
                  <th class="font-bold">Size</th>
                  <th class="font-bold">Total</th>
                  <th class="font-bold">Date</th>
                  <th class="text-right font-bold">Action</th>
                </tr>
              </thead>
              <tbody v-for="(items,index) in latestorderex[select_o_nx].order_items">
                <tr>
                  <td>
					   <responsive-image
            
								v-bind:desktop="`${$root.image_url_c}inside/900x450/${items.image}`"
								v-bind:tab="`${$root.image_url_c}inside/600x280/${items.image}`"
								v-bind:mobile="`${$root.image_url_c}inside/650x280/${items.image}`"
								v-bind:default_image="`${$root.image_url_c}inside/800x250/${items.image}`"
								width='60px'
									
							/>
					  <span>{{items.name}}</span></td>
                  <td class="qty cart-item">
                    {{items.qty}}
                  </td>
                  <td v-text="items.size" class="size"></td>
                  <td class="total">Rs. {{items.row_total}}</td>
                  <td v-text="items.created_at" class="order-date"></td>
                  <td class="action text-right"><a href="#" @click.prevent="select_item_ex(index)" v-if="index != return_id && Object.keys(latestorder[select_o_nx].order_items).length > 1">Exchange</a></td>
                  
                </tr>
                <tr v-if="index==return_id || Object.keys(latestorder[select_o_nx].order_items).length == 1">
                  <td colspan="6" class="select-order">
                    <form class="reasons_form" @submit="request_exchange(select_o_nx,index,items.qty,items.name,items.sku)">
                      <div class="reason-container mb-3 w-100 cart-item">
                      <label>Select Quantity</label>
                      <div class="qty_box" style="width: 130px;">
                      <a href="#" class="" @click.prevent="qty_minus" v-bind:class="{disabled:qty == 1}"><i class="fa fa-minus"></i></a>
                        <input type="text" :max="items.qty" min="1" v-model="qty" readonly="readonly">
                      <a href="#" class="" @click.prevent="qty_plus(items.qty)" v-bind:class="{disabled:items.qty == qty}"><i class="fa fa-plus"></i></a><span> /</span> <span>{{items.qty}}</span>
                      </div>
                      <div class="total_price">Total:  Rs. {{(items.row_total * qty) / items.totalQty }}</div>
                      </div>

                      <div class="product-detail-container">
                        <div class="size-container">
                          <label>Select New Size</label>
                          <div class="size-box">
                              <label class="size select-one-size" v-for="(item,index) in items.variation" @click="select_size" v-bind:class="{ disabled: item.quantity <= '0' || items.size === item.configrable_atribute_value, currentsize: items.size === item.configrable_atribute_value, selected: size.select_size === item.configrable_atribute_value}">
                                  <div class="size-buttons-sizeTip" v-if="item.size_hint!=null">
                                      <div class="size-buttons-sizeTipMeta">{{item.size_hint}}</br>Size: {{item.configrable_atribute_value}}</div>
                                  </div>
                                  <input type="radio" v-model="size" name="size" :value="{select_size:item.configrable_atribute_value, max_qty:item.quantity, variant_id:item.id_product, sku:item.sku}" v-bind:disabled="(item.quantity <= '0' ) === true"><span v-text="item.configrable_atribute_value"></span>
                              </label>
                              <p style="color: red; font-size: 14px; margin-bottom: 0;">{{size_error}}</p>
                          </div>
                        </div>
                      </div>
                      
                      <div class="reason-container mb-3">
                        <!-- <label>Exchange Reason</label> -->
                        <textarea class="w-100 form-control" placeholder="Please Enter Exchange Reason*" maxlength="490" @keyup="select_reason" v-model="exchange_resion"></textarea>
                        <p style="color:red;font-size:var(--font-size-regular);">{{reason_error}}</p>
                      </div>

                      <div class="reason-container comments mb-3">
                        <!-- <label>Exchange Reason</label> -->
                        <textarea class="w-100 form-control" placeholder="Comments (optional)" maxlength="490" v-model="exchange_comment"></textarea>
                      </div>
                      <button class="input-text form-control submit">Submit</button>  
                    </form>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>




  </div>
</template>

<script>
	import axios from "axios";
	 
	export default {
		name: "order",
		components: { },
		metaInfo: {
			title: "Return/Exchange",
			meta: [
				{
					name: "description",
					content: "",
				},
				{
					property: "keywords",
					content: "",
				},
			],
		},
		data() {
			return {
				select_o_n: "",
				select_o_nx: "",
				order: [],
				qty: 1,
				latestorder: [],
				latestorderex: [],
				return_popup: true,
				exchange_popup: true,
				return_id: "",
				exchange_id: "",
				select_resion: "",
				exchange_resion: "",
				ordertype: "",
				ac_holder_name: "",
				ac_number: "",
				re_ac_number: "",
				ac_ifsc_code: "",
				variation: [],
				size_error: "",
				ac_holder_name_error: "",
				ac_number_error: "",
				re_ac_number_error: "",
				ifsc_code_error: "",
				reason_error: "",
				exchange_comment: "",
				return_comment: "",
				size: {
					select_size: "",
					max_qty: "1",
					variant_id: "",
					sku: "",
				},
			};
		},
		methods: {
			qty_minus() {
				if (this.qty > 1) {
					this.qty = this.qty - 1;
				}
			},
			qty_plus(v) {
				if (this.qty < v) {
					this.qty = this.qty + 1;
				}
			},
			close_popup() {
				this.return_popup = true;
			},
			close_popup_ex() {
				this.exchange_popup = true;
			},
			select_size: function () {
				this.size_error = "";
			},
			select_reason: function () {
				this.reason_error = "";
			},
			select_holder_name: function () {
				var h_name = /^([^\s]+[a-z ,A-Z, ])+$/;
				if (this.ac_holder_name.match(h_name)) {
					this.ac_holder_name_error = "";
				} else {
					this.ac_holder_name_error = "Please enter valid Name";
				}
			},
			select_ac_number: function () {
				this.ac_number_error = "";
			},
			re_select_ac_number: function () {
				this.re_ac_number_error = "";
			},
			select_ifsc_code: function () {
				this.ifsc_code_error = "";
			},
			select_item(v) {
				this.return_id = v;
				this.select_resion = "";
				this.size.select_size = "";
				this.size.sku = "";
				this.return_comment = "";
				//console.log(this.select_o_n);
				this.ordertype = this.latestorder[this.select_o_n].ordertype;
				if (this.latestorder[this.select_o_n].accountInfo) {
					this.ac_holder_name = this.latestorder[
						this.select_o_n
					].accountInfo.account_holder_name;
					this.ac_number = this.latestorder[
						this.select_o_n
					].accountInfo.account_number;
					this.re_ac_number = this.latestorder[
						this.select_o_n
					].accountInfo.account_number;
					this.ac_ifsc_code = this.latestorder[
						this.select_o_n
					].accountInfo.ifsc_code;
				} else {
					this.ac_holder_name = "";
					this.ac_number = "";
					this.ac_ifsc_code = "";
					this.re_ac_number = "";
				}
				this.qty = 1;
			},
			select_item_ex(v) {
				this.return_id = v;
				this.size.select_size = "";
				this.size.sku = "";
				this.exchange_resion = "";
				this.exchange_comment = "";
				this.qty = 1;
			},
			reorder(cart_id) {
				this.$root.page_loader = true;
				var form = new FormData();
				form.append("cart_id", cart_id);
				axios
					.post(this.$root.cart_api + "/order/re-order", form)
					.then((response) => {
						if (response.data.success === true) {
							$cookies.set(
								window.location.hostname.substring(10, 4) + "_cart",
								response.data.data.cart_id
							);
							this.$root.cart_id = response.data.data.cart_id;
							this.$root.thankyou_cart = response.data.data.cart_id;
							this.$router.push("checkout.html");
							this.$root.page_loader = false;
						} else {
							window.scrollTo(0, 0);
							this.$root.page_loader = false;
							this.$root.error_message = response.data.message;
						}
					})
					.catch((error) => {
						this.$root.page_loader = false;
						if (error.message === "Network Error") {
							this.$root.error_message =
								"Oops there seems to be some Network issue, please try again.";
						}
						window.scrollTo(0, 0);
					});
			},
			get_account: function () {
				if (this.$root.customer_id != null && this.$root.customer_id != "") {
					this.$root.error_message = "";
					this.$root.success_message = "";
					var form = new FormData();
					form.append("customer_id", this.$root.customer_id);
					form.append("customer_session", this.$root.customer_session);
					form.append("store", this.$root.store);
					axios
						.post(this.$root.cart_api + "/customer/returned-items", form)
						.then((response) => {
							if (response.data.success === true) {
								this.$root.page_loader = false;
								this.order = response.data.data;
							} else {
								this.$root.page_loader = false;
								this.$root.error_message = response.data.message;
							}
						})
						.catch((error) => {
							this.$root.page_loader = false;
							if (error.message === "Network Error") {
								this.$root.error_message = error.message;
							}
							window.scrollTo(0, 0);
						});
				}
			},
			request_return(order, item_id, itemqty, name, sku) {
				event.preventDefault();
				//console.log(this.ordertype);
				if (
					(this.ac_holder_name === "" || this.ac_holder_name === "") &&
					this.ordertype == "cod"
				) {
					this.ac_holder_name_error = "Please enter account holder name";
					this.$toast.error("Please enter account holder name", {
						position: "top",
						duration: 4000,
					});
				} else if (
					(this.ac_number === "" || this.ac_number === null) &&
					this.ordertype == "cod"
				) {
					this.ac_number_error = "Please enter account number";
					this.$toast.error("Please enter account number", {
						position: "top",
						duration: 4000,
					});
				} else if (this.ac_number !== this.re_ac_number) {
					this.re_ac_number_error = "Account number not match";
					this.$toast.error("Account number not match", {
						position: "top",
						duration: 4000,
					});
				} else if (
					(this.ac_ifsc_code === "" || this.ac_ifsc_code === null) &&
					this.ordertype == "cod"
				) {
					this.ifsc_code_error = "Please enter IFSC code";
					this.$toast.error("Please enter IFSC code", {
						position: "top",
						duration: 4000,
					});
				} else {
					if (this.$root.customer_id != null && this.$root.customer_id != "") {
						this.$root.page_loader = true;
						this.$root.error_message = "";
						this.$root.success_message = "";
						var form = new FormData();
						form.append("order_id", order);
						form.append("item_id", item_id);
						form.append("customer_id", this.$root.customer_id);
						form.append("customer_session", this.$root.customer_session);
						form.append("qty", this.qty);
						form.append("name", name);
						form.append("sku", sku);
						form.append("return_reasons", this.select_resion);
						form.append("comment", this.return_comment);
						form.append("account_holder_name", this.ac_holder_name);
						form.append("account_no", this.ac_number);
						form.append("ifsc_code", this.ac_ifsc_code);
						axios
							.post(this.$root.cart_api + "/customer/return-request", form)
							.then((response) => {
								if (response.data.success === true) {
									this.$root.page_loader = false;
									this.select_o_n = "";
									this.latestorder = [];
									this.return_popup = true;
									this.$toast.success(response.data.message, {
										position: "top",
										duration: 4000,
									});
									this.get_account();
								} else {
									this.$root.page_loader = false;
									this.$toast.error(response.data.message, {
										position: "top",
										duration: 4000,
									});
								}
							})
							.catch((error) => {
								this.$root.page_loader = false;
								if (error.message === "Network Error") {
									this.$root.error_message = error.message;
								}
								window.scrollTo(0, 0);
							});
					}
				}
			},
			request_exchange(order, item_id, itemqty, name, sku) {
				event.preventDefault();
				if (this.size.select_size === "" || this.size.select_size === "") {
					this.size_error = "Please select a size first";
					this.$toast.error("Please select a size first.", {
						position: "top",
						duration: 4000,
					});
				} else if (this.exchange_resion === "" || this.exchange_resion === null) {
					this.reason_error = "Please write a reason to exchange";
					this.$toast.error("Please write a reason to exchange.", {
						position: "top",
						duration: 4000,
					});
				} else {
					if (this.$root.customer_id != null && this.$root.customer_id != "") {
						this.$root.page_loader = true;
						this.$root.error_message = "";
						this.$root.success_message = "";
						var form = new FormData();
						form.append("order_id", order);
						form.append("item_id", item_id);
						form.append("customer_id", this.$root.customer_id);
						form.append("customer_session", this.$root.customer_session);
						form.append("qty", this.qty);
						form.append("name", name);
						form.append("sku", this.size.sku);
						form.append("size", this.size.select_size);
						form.append("exchange_reasons", this.exchange_resion);
						form.append("comment", this.exchange_comment);
						axios
							.post(this.$root.cart_api + "/customer/exchange-request", form)
							.then((response) => {
								if (response.data.success === true) {
									this.$root.page_loader = false;
									this.select_o_nx = "";
									this.latestorderex = [];
									this.exchange_popup = true;
									this.$toast.success(response.data.message, {
										position: "top",
										duration: 4000,
									});
									this.get_account();
								} else {
									this.$root.page_loader = false;
									this.$toast.error(response.data.message, {
										position: "top",
										duration: 4000,
									});
								}
							})
							.catch((error) => {
								this.$root.page_loader = false;
								if (error.message === "Network Error") {
									this.$root.error_message = error.message;
								}
								window.scrollTo(0, 0);
							});
					}
				}
			},
			order_return: function () {
				if (this.$root.customer_id != null && this.$root.customer_id != "") {
					this.$root.page_loader = true;
					this.$root.error_message = "";
					this.$root.success_message = "";
					var form = new FormData();
					form.append("customer_id", this.$root.customer_id);
					form.append("customer_session", this.$root.customer_session);
					form.append("store", this.$root.store);
					axios
						.post(this.$root.cart_api + "/customer/return-orders", form)
						.then((response) => {
							if (response.data.success === true) {
								this.$root.page_loader = false;
								this.latestorder = response.data.data;
								this.return_popup = false;
							} else {
								this.$root.page_loader = false;
								this.$root.error_message = response.data.message;
							}
						})
						.catch((error) => {
							this.$root.page_loader = false;
							if (error.message === "Network Error") {
								this.$root.error_message = error.message;
							}
							window.scrollTo(0, 0);
						});
				}
			},
			order_exchange: function () {
				if (this.$root.customer_id != null && this.$root.customer_id != "") {
					this.$root.page_loader = true;
					this.$root.error_message = "";
					this.$root.success_message = "";
					var form = new FormData();
					form.append("customer_id", this.$root.customer_id);
					form.append("customer_session", this.$root.customer_session);
					form.append("store", this.$root.store);
					axios
						.post(this.$root.cart_api + "/customer/exchange-orders", form)
						.then((response) => {
							if (response.data.success === true) {
								this.$root.page_loader = false;
								this.latestorderex = response.data.data;
								this.exchange_popup = false;
							} else {
								this.$root.page_loader = false;
								this.$root.error_message = response.data.message;
							}
						})
						.catch((error) => {
							this.$root.page_loader = false;
							if (error.message === "Network Error") {
								this.$root.error_message = error.message;
							}
							window.scrollTo(0, 0);
						});
				}
			},
		},
		mounted() {
			this.get_account();
		},
		created() {
			if (this.$root.customer_id === null || this.$root.customer_id === "") {
				this.$router.push("login.html");
			}
			(this.$root.error_message = ""),
				(this.$root.success_message = ""),
				(this.$root.breadcrumb = "Return"),
				(this.$root.page_loader = false);
		},
	};
</script>